import { FC, useEffect, useState } from 'react'

import { useViewportBreakpoints } from '@syconium/little-miss-figgy'

import { SlideItemPopperProps } from '../constants'
import { PopUpWrapper } from '../style'

interface PopUpProps {
  popper?: SlideItemPopperProps
  title: string
}

const PopUp: FC<PopUpProps> = ({ popper, title }) => {
  const [hide, setHide] = useState(true)
  const [currentPopper, setCurrentPopper] = useState<SlideItemPopperProps | undefined>()
  const viewport = useViewportBreakpoints()

  useEffect(() => {
    setHide(true)
    if (popper && (popper?.image !== currentPopper?.image || currentPopper === undefined)) {
      setTimeout(() => {
        setCurrentPopper(popper)
        setHide(false)
      }, 100)
    }
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popper])

  return (
    <>
      {!hide &&
        currentPopper &&
        (currentPopper?.viewport === viewport || !currentPopper.viewport) && (
          <PopUpWrapper
            src={currentPopper.image}
            alt={title}
            maxWidth={currentPopper.maxWidth}
            top={currentPopper.top}
            left={currentPopper.left}
            right={currentPopper.right}
          />
        )}
    </>
  )
}

export default PopUp
